import React from 'react';
import { Brain, Clock, Mail, BookOpen, Target, Lightbulb } from 'lucide-react';
import './Features.css';

function Features() {
  const features = [
    {
      icon: <Brain size={32} />,
      title: 'AI-Powered Content Ideas',
      description: 'Our AI analyzes trending discussions and industry insights to transform them into engaging LinkedIn content ideas tailored to your voice.'
    },
    {
      icon: <Clock size={32} />,
      title: 'Effortless Content Creation',
      description: 'From opening your email to publishing a polished post in just a few clicks—save hours of brainstorming and writing every week.'
    },
    {
      icon: <Mail size={32} />,
      title: 'Email-Based System',
      description: 'Receive content ideas directly in your inbox. Select your favorite, choose a tone, and get the final polished post delivered via email.'
    },
    {
      icon: <BookOpen size={32} />,
      title: 'Storytelling Categories',
      description: 'Choose from categories designed to help you build your profile\'s story—Professional Insights, Casual Updates, Inspirational Stories, Thought-Provoking Ideas, and Authentic Storytelling.'
    },
    {
      icon: <Target size={32} />,
      title: 'Personalized for You',
      description: 'Content is generated based on your role, industry, and professional goals. Every idea is relevant and authentic to your expertise.'
    },
    {
      icon: <Lightbulb size={32} />,
      title: 'Overcome Writer\'s Block',
      description: 'Never stare at a blank screen again. Get a consistent flow of fresh, engaging content ideas every week.'
    }
  ];

  return (
    <section className="features" id="features" data-testid="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title" data-testid="features-title">
            Everything You Need to
            <span className="gradient-text-features"> Build Your Brand</span>
          </h2>
          <p className="features-subtitle" data-testid="features-subtitle">
            Story Engine handles the heavy lifting so you can focus on engaging with your audience
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index} data-testid={`feature-card-${index}`}>
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;